<!--
  Two stacked icon buttons. Each is 28 × 32 px, clearing WCAG 2.2 AA's 24 × 24 minimum on its own (see the
  style guide's note on tap targets), and the pair forms one 56 px column in a row that is already ~96 px
  tall — so the control adds no height at any viewport width and needs no responsive variant.

  `type="button"` on both: this sits inside the article form, and a default-type button would submit it —
  i.e. save the article — instead of moving a slot.
-->
<div class="flex w-8 shrink-0 flex-col justify-center">
  <button (click)="move.emit('up')"
          [attr.aria-label]="upLabel()"
          [disabled]="isFirst()"
          class="flex h-7 w-8 cursor-pointer items-center justify-center rounded-t-md text-gray-500
                 transition-colors hover:bg-gray-100 hover:text-theme-primary-700
                 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                 focus-visible:outline-theme-primary-500
                 disabled:cursor-not-allowed disabled:text-gray-300 disabled:hover:bg-transparent
                 disabled:hover:text-gray-300"
          type="button">
    <span aria-hidden="true" class="icon-[ph--caret-up] align-middle text-lg"></span>
  </button>
  <button (click)="move.emit('down')"
          [attr.aria-label]="downLabel()"
          [disabled]="isLast()"
          class="flex h-7 w-8 cursor-pointer items-center justify-center rounded-b-md text-gray-500
                 transition-colors hover:bg-gray-100 hover:text-theme-primary-700
                 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                 focus-visible:outline-theme-primary-500
                 disabled:cursor-not-allowed disabled:text-gray-300 disabled:hover:bg-transparent
                 disabled:hover:text-gray-300"
          type="button">
    <span aria-hidden="true" class="icon-[ph--caret-down] align-middle text-lg"></span>
  </button>
</div>
